import React, { createContext, useContext, useState } from "react";

const ContactsContext = createContext();

export const ContactsProvider = ({ children }) => {
  const [inspectionView, setInspection] = useState(false);
  const [equipmentsView, setEquipments] = useState(false);
  const [serviceView, setService] = useState(false);
  const [invoiceView, setInvoice] = useState(false);
  const [isContractViewUpdate, setIsContractViewUpdate] = useState(false);

  const updateInspection = (newCurrency) => {
    setInspection(newCurrency);
  };
  const updateEquipments = (newCurrency) => {
    setEquipments(newCurrency);
  };

  const updateService = (newCurrency) => {
    setService(newCurrency);
  };

  const updateInvoice = (newCurrency) => {
    setInvoice(newCurrency);
  };

  const updateIsContractViewUpdate = (newCurrency) => {
    setIsContractViewUpdate(newCurrency);
  };

  return (
    <ContactsContext.Provider
      value={{
        inspectionView,
        updateInspection,
        equipmentsView,
        updateEquipments,
        serviceView,
        updateService,
        invoiceView,
        updateInvoice,
        isContractViewUpdate,
        updateIsContractViewUpdate,
      }}
    >
      {children}
    </ContactsContext.Provider>
  );
};

export const useContacts = () => {
  const context = useContext(ContactsContext);
  if (!context) {
    throw new Error("useStandard must be used within a CurrencyContext");
  }
  return context;
};
